import { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { formManager, recordActions, Auth } from '../../config/configuration/react';
import { Record } from '../../config/Record/RecordEntity';
import { intervalGetRecordDetails } from '../../config';

const useRecord = (recordIdInit, dataType = null) => {
  const recordId = parseInt(recordIdInit, 10);
  const dispatch = useDispatch();
  const vehicleId = useSelector((state) => state.reduxRecords.data[recordId])?.record?.autobizTradeUuid;
  const autobizTradeDate = useSelector((state) => state.reduxRecords.data[recordId])?.record?.autobizTradeDate;
  const isRecordLoading = useSelector((state) => state.reduxRecords.loading);
  const errorRecordApi = useSelector((state) => state.reduxRecords.error);
  const record = useSelector((state) => state.reduxRecords.data[recordId]);
  const formId = useSelector((state) => state.reduxRecords.data[recordId])?.record?.formId;
  const statusId = useSelector((state) => state.reduxRecords.data[recordId])?.record?.statusId;
  const entryStockOption = useSelector((state) => state.reduxRecords.data[recordId])?.entryStockOption;
  const trade = useSelector((state) => state.reduxRecords.data[recordId]?.trade || {});
  const source = useSelector((state) => state.reduxRecords.data[recordId])?.sourceInfos;
  const buyers = useSelector((state) => state.reduxRecords.data[recordId])?.buyers;
  const recordEntity = new Record(record);
  const [called, setCalled] = useState(false);

  const getRecordData = async () => {
    if (recordId > 0) {
      dispatch(recordActions.openRecord(recordId));
    }
  };

  const getSaleData = async () => {
    if (
      Object.keys(trade).length === 0 &&
      vehicleId !== null &&
      autobizTradeDate !== null &&
      autobizTradeDate !== undefined
    ) {
      dispatch(recordActions.getSale(recordId));
    }
  };

  const unlockPricing = async () => {
    await dispatch(recordActions.unlockPricing(recordId));
  };

  const fetchData = async () => {
    if (formId && statusId && statusId === 2) {
      const localStatus = await formManager.getLocalStatus(formId);
      if (localStatus !== 3) {
        await formManager.updateFormIfUpdated(formId);
      }
    }
  };

  const getVersinsData = async () => {
    if (called) return;
    setCalled(true);
    if (dataType === 'all' && recordEntity.status() !== undefined && recordEntity.displayBlocsIsAllowed())
      await dispatch(recordActions.getVehicleVersions(recordId));
    if (!entryStockOption) await dispatch(recordActions.getEntryStockOption(recordId));
    if (!source || source.id !== recordEntity.getSourceId()) await dispatch(recordActions.getSourceInfo(recordId));
    setCalled(false);
  };
  const getRecordBuyers = async () => {
    if (Auth.isAllowedToChangeBuyer() && !buyers?.length && recordEntity.getSourceId() && record?.record?.countryId)
      await dispatch(recordActions.getBuyersBySource(recordId, recordEntity.getSourceId(), record?.record?.countryId));
  };

  const checkIfRecordUpdatedOnApi = () => {
    dispatch(recordActions.refreshIfNecessary());
  };

  useEffect(() => {
    const interval = setInterval(() => {
      checkIfRecordUpdatedOnApi();
    }, intervalGetRecordDetails);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const intervalForm = setInterval(() => {
      fetchData();
    }, intervalGetRecordDetails);
    return () => clearInterval(intervalForm);
  }, [formId, statusId]);

  useEffect(() => {
    unlockPricing();
    getRecordData();
  }, [recordId]);

  useEffect(() => {
    getSaleData();
  }, [vehicleId, autobizTradeDate, trade, recordId]);

  useEffect(() => {
    getVersinsData();
  }, [record]);
  useEffect(() => {
    getRecordBuyers();
  }, [record?.record?.sourceId]);
  const counterInspectionHasConfigForm = useMemo(() => {
    const { b2bFormCa, b2cFormCa } = source?.sourceGroupData || {};
    return b2bFormCa || b2cFormCa;
  }, [source]);

  const updateAfterIndexedDBevent = (e) => {
    if (e.key && e.key.includes(`${formId}-synchronized`)) dispatch(recordActions.getRemoteRecord(recordId));
  };

  useEffect(() => {
    window.addEventListener('storage', updateAfterIndexedDBevent);
    return () => {
      window.removeEventListener('storage', updateAfterIndexedDBevent);
    };
  }, []);

  return {
    record,
    isRecordLoading,
    errorRecordApi,
    formId,
    vehicleId,
    recordEntity,
    counterInspectionHasConfigForm,
    autobizTradeDate,
  };
};

export default useRecord;
